import React from 'react';
import Footer from '../components/Footer';
import credits from './dataCredits.json';
import './LegalPages.css';

// The open data and assets the 3D worlds and maps are built from, each with its credit and licence. The list is
// generated from the source registries (scripts/legal/data_credits.py): edit those, not dataCredits.json.
function DataCreditsPage() {
    return (
        <div className="container legal-page">
            <h1>🗺️ Map Data Credits</h1>
            <p className="effective-date"><strong>Updated: {credits.updated}</strong></p>

            <p>MythicMaps' 3D worlds, maps and videos are built from open data published by the organisations below, each
                under its own licence. We thank them, and credit each one here as its licence asks.</p>

            {credits.sections.map(section => (
                <section key={section.title}>
                    <h2>{section.title}</h2>
                    {section.intro && <p>{section.intro}</p>}
                    <ul>
                        {section.items.map(item => (
                            <li key={item.name + item.credit}>
                                {item.url ? <a href={item.url} target="_blank" rel="noopener noreferrer">{item.credit}</a> : item.credit}
                                {item.licence && item.licence !== item.credit && !item.credit.includes(item.licence) &&
                                    <span className="credit-licence"> ({item.licence})</span>}
                            </li>
                        ))}
                    </ul>
                </section>
            ))}

            <Footer />
        </div>
    );
}

export default DataCreditsPage;
